import useToast from '@hooks/ui/useToast';
import { CartStatus } from '@models/cart';
import { useFlow } from '@router/stackflow';
import useCalculatedCart from '@store/cart/hooks/useCalculatedCart';
import { useTranslation } from 'react-i18next';

function useCartFooter() {
    const toast = useToast();
    const { push } = useFlow();
    const { orderLines, totalAmount } = useCalculatedCart();
    const { t } = useTranslation('cart');
    const soldOutList = orderLines
        .filter((item) => item.status !== CartStatus.ON_SALE);
    const isEmpty = orderLines.length === 0;
    const isAllSoldOuted = soldOutList.length === orderLines.length && !isEmpty;

    const handleOrder = () => {
        if (isAllSoldOuted) {
            toast.error(t('toast.allSoldOut'));
            return;
        }
        if (soldOutList.length !== 0) {
            toast.info(t('toast.soldOutExcluded'));
        }
        push('OrderActivity', { path: 'cart' });
    };

    return {
        handleOrder,
        totalAmount,
        isAllSoldOuted,
        isEmpty,
    };
}

export default useCartFooter;
